import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import SectionTitle from 'components/section-title'
import { TonalButton } from 'components/empty-page-state'
import EventIcon from 'components/material-symbol/icons/Event'
import GroupIcon from 'components/material-symbol/icons/Group'
import BlockIcon from 'components/material-symbol/icons/Block'
import CalendarAddOnIcon from 'components/material-symbol/icons/CalendarAddOn'
import { RefetchContext } from 'lib/utils/refetchContext'
import { CreateEventQuickStartOverlay } from 'pages/pga-coach/bookings/events/create-event-form/form-sections/create-event-quick-start'
import useCreateEventQuickStart from 'pages/pga-coach/bookings/events/use-create-event-quick-start'
import useAddTimeDialogs from 'pages/pga-coach/settings/availability/availability-tab/use-add-time-dialogs'
import useAddBookingAction from '../manage-business/use-add-booking-action'
import useStyles from './styles'

export const QuickActionsView = ({
  addBooking,
  onCreateGroupEvent,
  onBlockTime,
  onOpenTime,
  isAddTimeLoading = false,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.card}>
      <Box className={classes.cardHeader}>
        <SectionTitle size="card" className={classes.cardTitle}>
          Quick actions
        </SectionTitle>
      </Box>
      <Box className={classes.list}>
        {addBooking ? (
          <TonalButton
            className={classes.action}
            startIcon={<EventIcon aria-hidden />}
            component={addBooking.href ? 'a' : undefined}
            href={addBooking.href}
            onClick={addBooking.onClick}
          >
            Add Booking
          </TonalButton>
        ) : null}
        <TonalButton
          onClick={onCreateGroupEvent}
          className={classes.action}
          startIcon={<GroupIcon aria-hidden />}
        >
          Create Group Event
        </TonalButton>
        <TonalButton
          onClick={onBlockTime}
          disabled={isAddTimeLoading}
          className={classes.action}
          startIcon={<BlockIcon aria-hidden />}
        >
          Block Time
        </TonalButton>
        <TonalButton
          onClick={onOpenTime}
          disabled={isAddTimeLoading}
          className={classes.action}
          startIcon={<CalendarAddOnIcon aria-hidden />}
        >
          Open Time
        </TonalButton>
      </Box>
    </Box>
  )
}

QuickActionsView.propTypes = {
  addBooking: PropTypes.shape({
    href: PropTypes.string,
    onClick: PropTypes.func,
  }),
  onCreateGroupEvent: PropTypes.func,
  onBlockTime: PropTypes.func,
  onOpenTime: PropTypes.func,
  isAddTimeLoading: PropTypes.bool,
}

// With fast book on, Add Booking opens the "Book a student" overlay. With it
// off it follows the schedule page's Book Student link to the booking page.
// Create Group Event, Block Time and Open Time open their dialogs over the
// dashboard, and saving refreshes Today's schedule.
const QuickActions = ({ isGroupEventsLimitReached = false }) => {
  const createEventQuickStart = useCreateEventQuickStart({
    canBuildOwnEvent: !isGroupEventsLimitReached,
  })
  const refreshBookings = useContext(RefetchContext)
  const addTimeDialogs = useAddTimeDialogs({ onSuccess: refreshBookings })
  const addBooking = useAddBookingAction({
    formLabel: 'dashboard-quick-actions',
  })

  return (
    <>
      <QuickActionsView
        addBooking={addBooking}
        onCreateGroupEvent={createEventQuickStart.open}
        onBlockTime={addTimeDialogs.openBlockedTime}
        onOpenTime={addTimeDialogs.openOpenTime}
        isAddTimeLoading={addTimeDialogs.isLoading}
      />
      {addTimeDialogs.dialogs}
      {createEventQuickStart.isOpen ? (
        <CreateEventQuickStartOverlay {...createEventQuickStart.overlayProps} />
      ) : null}
    </>
  )
}

QuickActions.propTypes = {
  isGroupEventsLimitReached: PropTypes.bool,
}

export default QuickActions
